exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider[data-v-3635432c]{height:3px;margin-top:40px;margin-bottom:-22px;background-color:#f84a5f}.title-divider[data-v-3635432c]{background-color:#efefef;padding:0 40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3635432c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/TitleDivider.vue
// module id = eRWJ
// module chunks = 102